import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlaystation2Component } from './simple-icons-playstation2.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlaystation2Component ],
    exports:      [ SimpleIconsPlaystation2Component ],
    bootstrap:    []
})
export class SimpleIconsPlaystation2Module {}
